






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { HumanitiesOrSciences } from '@/models/school-group/school-group-trend-analysis';
import moment from 'moment';

@Component({
  name: 'GTrendAnalysisHumanitiesOrSciencesChart',
})
export default class GTrendAnalysisHumanitiesOrSciencesChart extends mixins(GPageBase) {
  @Prop() data: HumanitiesOrSciences;
  chartOptions: any = {};

  mounted() {
    this.chartOptions = {
      title: [
        { left: 'center', top: 10, text: this.$t('NUMANITIES_OR_SCIENCES').toString() },
        {
          show: true,
          text: this.$t('HUMANITIES').toString(),
          textStyle: {
            color: 'orange',
          },
          bottom: '4%',
          left: '7%',
        },
        {
          show: true,
          text: this.$t('SCIENCES').toString(),
          textStyle: {
            color: 'blue',
          },
          bottom: '4%',
          right: '7%',
        },
      ],
      legend: {
        data: [this.latestLabelName, this.lastLabelName],
        top: 35,
        center: 0,
      },
      grid: { width: '80%', height: '80%', top: 'auto', left: 'auto' },
      xAxis: [
        {
          type: 'value',
          name: this.$t('NUMANITIES_OR_SCIENCES').toString(),
          nameLocation: 'center',
          nameTextStyle: { fontWeight: 'bold' },
          nameGap: 15,
          min: -100,
          max: 100,
          axisLabel: {
            // 文系をマイナス値として表示させたくないので、x軸自体表示しない
            show: false,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          // name: '人数', //barチャート出す場合はコメントアウト戻す
          nameLocation: 'center',
          nameTextStyle: { fontWeight: 'bold' },
          nameGap: 30,
          min: 0,
          axisLabel: {
            // y軸自体の目盛りを表示させない
            show: false,
          },
        },
      ],
      series: [
        // barチャートは表示しない
        {
          name: this.lastLabelName,
          type: 'line',
          showSymbol: false,
          clip: true,
          itemStyle: { opacity: 0.7, color: 'gray' },
          data: this.lastNormalDistributionData,
          z: 1,
        },
        {
          name: this.latestLabelName,
          type: 'line',
          showSymbol: false,
          clip: true,
          itemStyle: { opacity: 0.7, color: 'blue' },
          data: this.latestNormalDistributionData,
          z: 2,
        },
      ],
    };
  }

  addSeries() {}

  // ラベル名（今回）
  get latestLabelName() {
    if (this.data.latestData.examDate) {
      return this.$t('LATEST').toString() + `：（${moment(this.data.latestData.examDate).format('YYYY-MM-DD')}）`;
    }
    return this.$t('LATEST').toString();
  }

  // ラベル名（前回）
  get lastLabelName() {
    if (this.data.lastData.examDate) {
      return this.$t('LAST_TIME').toString() + `：（${moment(this.data.lastData.examDate).format('YYYY-MM-DD')}）`;
    }
    return this.$t('LAST_TIME').toString() + `：（ー）`;
  }

  // 今回の分布(Count)データ
  get latestDistributionCountData() {
    return this.data.latestData.trendData.map((d: any) => d[2]);
  }

  // 今回の分布(Chart)データ
  get latestDistributionChartData() {
    // x軸の範囲（d[0]からd[1]までの10の範囲）の中間に、x軸をプロットする
    return this.data.latestData.trendData.map((d: any) => [d[0] + 5, d[2]]);
  }

  // 前回の分布(Count)データ
  get lastDistributionCountData() {
    return this.data.lastData.trendData.map((d: any) => d[2]);
  }

  // 前回の分布(Chart)データ
  get lastDistributionChartData() {
    // x軸の範囲（d[0]からd[1]までの10の範囲）の中間に、x軸をプロットする
    return this.data.lastData.trendData.map((d: any) => [d[0] + 5, d[2]]);
  }

  normalDistribution(x: number, mean: number, stdDev: number) {
    return (1 / (stdDev * Math.sqrt(2 * Math.PI))) * Math.exp(-0.5 * Math.pow((x - mean) / stdDev, 2));
  }

  generateNormalDistributionData(mean: number, stdDev: number) {
    let data = [];
    for (let i = -100; i <= 100; i += 0.1) {
      data.push([i, this.normalDistribution(i, mean, stdDev)]);
    }
    return data;
  }

  get latestNormalDistributionData() {
    if (this.data.latestMean && this.data.latestStandardDeviation) {
      return this.generateNormalDistributionData(this.data.latestMean, this.data.latestStandardDeviation);
    }
    return [];
  }

  get lastNormalDistributionData() {
    if (this.data.lastMean && this.data.lastStandardDeviation) {
      return this.generateNormalDistributionData(this.data.lastMean, this.data.lastStandardDeviation);
    }
    return [];
  }
}
